import React, { useState, useRef, useEffect } from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";
import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";

const El = styled(motion.div)`
  overflow: hidden;
  margin-left: -2px;
  margin-right: -2px;
  padding-left: 2px;
  padding-right: 2px;
  flex-shrink: 0;

  ${({ open }) =>
    open &&
    css`
      margin-bottom: auto;
    `}
`;

const Description = styled.div`
  padding-top: ${rem(10)};
  font-weight: normal;
  font-size: ${rem(13)};
  line-height: 1.5;
  color: #5c5e62;
  font-family: sans-serif;
`;

const SubSectionContainer = styled.div`
  padding-bottom: ${rem(30)};
`;

const Section = ({
  index,
  open,
  setActiveSection,
  filled,
  title,
  description,
  children,
  changedField,
}) => {
  const ElRef = useRef(null);
  const [sectionHeight, setSectionHeight] = useState("auto");

  useEffect(() => {
    setSectionHeight(ElRef.current.offsetHeight);
  }, [open, changedField]);

  return (
    <>
      <SectionHeading
        setActiveSection={setActiveSection}
        open={open}
        filled={filled}
        title={title}
        index={index}
      />
      <El
        animate={open ? { height: sectionHeight } : { height: 0 }}
        open={open}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div ref={ElRef}>
          <motion.div
            animate={
              open
                ? {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.5, delay: 0.4 },
                  }
                : { opacity: 0, y: 10 }
            }
          >
            <Description>{description}</Description>
            <SubSectionContainer>{children}</SubSectionContainer>
          </motion.div>
        </div>
      </El>
    </>
  );
};

export default Section;
